<template>
    <span class="crane-loading-spinner" :style="spinnerStyle" aria-hidden="true" />
</template>

<script setup lang="ts">
/**
 * Ring spinner: size, border, and rotation only. Placement belongs to the
 * caller, which styles the root span (e.g. `CraneButton`'s `loadingReplace`
 * treatment absolutely centers it while the faded label holds the width).
 */

const props = withDefaults(
    defineProps<{
        /** Ring diameter in px. Border thickness scales with it. */
        size?: number
    }>(),
    {
        size: 18,
    }
)

/**
 * Exposed as custom properties (not plain width/height) so callers can reuse
 * the diameter for their own placement math, e.g. a centering offset.
 */
const spinnerStyle = computed(() => ({
    '--crane-loading-spinner-size': `${props.size}px`,
    '--crane-loading-spinner-thickness': `${Math.max(2, Math.round(props.size / 9))}px`,
}))
</script>

<style scoped>
.crane-loading-spinner {
    width: var(--crane-loading-spinner-size);
    height: var(--crane-loading-spinner-size);
    box-sizing: border-box;
    border-radius: 9999px;
    border: var(--crane-loading-spinner-thickness) solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    animation: crane-loading-spinner-spin 900ms linear infinite;
}

@keyframes crane-loading-spinner-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
